//TechTags data
const TechTags = [

    {
        "id": 22,
        "description": "Creating interfaces that allow different software applications to communicate and share data.",
        "name": "API Development",
        "slug": "api-development"
      },
      {
        "id": 19,
        "description": "Focused on server-side logic, databases, APIs, and cloud integration for application performance.",
        "name": "Backend Development",
        "slug": "backend-development"
      },
      {
        "id": 23,
        "description": "Writing clean, reusable, and optimized code that enhances software performance and reduces errors.",
        "name": "Efficient Coding",
        "slug": "efficient-coding"
      },
      {
        "id": 20,
        "description": "Building the visual elements of a website or app that users interact with, using HTML, CSS, and JavaScript.",
        "name": "Frontend Development",
        "slug": "frontend-development"
      },
      {
        "id": 18,
        "description": "Designing and building applications for mobile platforms like iOS and Android.",
        "name": "Mobile App Development",
        "slug": "mobile-app-development"
      },
      
      {
        "id": 24,
        "description": "Designing algorithms to solve problems efficiently, ensuring faster and more accurate results in software.",
        "name": "Programming Algorithms",
        "slug": "programming-algorithms"
      },
      {
        "id": 16,
        "description": "Understanding and utilizing various languages like Python, JavaScript, Java, and C++ for building software.",
        "name": "Programming Languages",
        "slug": "programming-languages"
      },
      {
        "id": 21,
        "description": "Harnessing the power of Python for building web apps, data analysis, AI projects, and more.",
        "name": "Python Programming",
        "slug": "python-programming"
      },
      {
        "id": 15,
        "description": "Crafting the software that powers applications, ensuring functionality, performance, and scalability",
        "name": "Software Development",
        "slug": "software-development"
      },
      {
        "id": 17,
        "description": "Creating websites and web applications, focusing on both the front-end and back-end development.",
        "name": "Web Development",
        "slug": "web-development"
      },
      {
        "id": 30,
        "description": "Creators are individuals who develop original ideas, products, or content, driving innovation across various fields such as art, technology, and entertainment.",
        "name": "Creators",
        "slug": "Creators"
      },
      {
        "id": 31,
        "description": "Inventors are individuals who create new ideas, devices, or processes that drive innovation and technological advancement.",
        "name": "Inventors",
        "slug": "Inventors"
      },
      {
        "id": 32,
        "description": "CAD (Computer-Aided Design) is software used for creating, modifying, and optimizing designs in various fields like engineering, architecture, and product design. It allows for precise 2D and 3D modeling, drafting, and simulation.",
        "name": "CAD",
        "slug": "CAD"
      },
      {
        "id": 33,
        "description":"Qt is a cross-platform framework for developing graphical user interfaces and applications. It supports C++ and QML, enabling developers to create high-performance, multi-platform apps with rich user interfaces",
        "name": "Qt",
        "slug": "Qt"
      },
      {
        "id": 34,
        "description": "Robotics involves the design, construction, operation, and use of robots, often incorporating sensors, actuators, and artificial intelligence to perform tasks autonomously or semi-autonomously. It is widely used in manufacturing, healthcare, and research, enabling automation and precision in various industries.",
        "name": "Robotics",
        "slug": "robotics"
      },
      
      {
        "id": 35,
        "description": "Modeling in computer-aided design (CAD) refers to the process of creating a digital representation of a physical object or system. It involves using specialized software to design and manipulate 3D models, which can be used for manufacturing, simulation, or visualization.",
        "name": "Modeling",
        "slug": "modeling"
      },
      {
        "id": 36,
        "description": "Automation refers to the use of technology to perform tasks without human intervention, often to increase efficiency and precision. It is widely applied in industries like manufacturing, logistics, and service.",
        "name": "Automation",
        "slug": "automation"
      },
      {
        "id": 37,
        "description": "Artificial Intelligence (AI) in robotics allows robots to perform tasks that typically require human intelligence, such as decision-making, problem-solving, and learning from experience.",
        "name": "Artificial Intelligence",
        "slug": "artificial-intelligence"
      },
      {
        "id": 38,
        "description": "Machine Learning is a subset of AI that enables robots to learn and improve from data without being explicitly programmed. It allows for more adaptive and intelligent robotic systems.",
        "name": "Machine Learning",
        "slug": "machine-learning"
      },
      {
        "id": 39,
        "description": "Robotic Process Automation (RPA) involves the use of robots to automate repetitive tasks in business processes, improving efficiency and reducing human error in various industries.",
        "name": "Robotic Process Automation",
        "slug": "robotic-process-automation"
      },
      {
        "id": 40,
        "description": "Robotic Engineering focuses on the design, construction, and operation of robots. It combines mechanical, electrical, and software engineering to create functional robots.",
        "name": "Robotic Engineering",
        "slug": "robotic-engineering"
      },
      {
        "id": 41,
        "description": "Autonomous Systems in robotics enable robots to perform tasks independently, making decisions based on their environment without requiring direct human control.",
        "name": "Autonomous Systems",
        "slug": "autonomous-systems"
      },
      {
        "id": 42,
        "description": "Mechatronics is an interdisciplinary field that combines mechanical engineering, electrical engineering, and computer science to design and build intelligent systems, including robots.",
        "name": "Mechatronics",
        "slug": "mechatronics"
      },
      {
        "id": 43,
        "description": "Robot Programming is the process of writing the code that enables robots to perform specific tasks. This includes both the high-level logic and the low-level control of robotic actions.",
        "name": "Robot Programming",
        "slug": "robot-programming"
      }


]

export default TechTags;
